import { createPlatformStyles, theme } from "../../theme/theme";

export const { ids, styles } = createPlatformStyles({
  mobile: {
    mainView: {
      backgroundColor: theme.colors.primary,
      overflow: "hidden",
      flex: 1,
      height: "100%",
      width: "100%",
    },
    bgEffect: {
      backgroundColor: theme.colors.primaryLight,
      position: "absolute",
      width: 400,
      height: 800,
      "@media (min-width: 700px)": {
        top: -272,
        left: -101,
      },
      top: -527,
      left: -101,
      transform: [{ rotate: "45deg" }],
    },
    container: { flex: 1, justifyContent: "center", alignItems: "center" },
    imgStyle: { resizeMode: "cover", top: 0 },
    headerContainer: {
      zIndex: theme.zIndex.max + 10,
    },
  },
  web: {
    mainView: {
      backgroundColor: theme.colors.primary,
      overflow: "hidden",

      flex: 1,
      height: "100%",
      width: "100%",
    },
    gradientBg: {
      backgroundImage: theme.colors.backgroundGradient,
    },
    bgEffect: {
      backgroundColor: theme.colors.primaryLight,
      position: "absolute",
      "@media (min-width: 700px)": {
        top: -272,
        left: -101,
      },
      top: -527,
      left: -101,
      transform: [{ rotate: "45deg" }],
      width: 400,
      height: 800,
    },
    container: { flex: 1, justifyContent: "center", alignItems: "center" },
    imgStyle: { resizeMode: "cover", top: 0 },
    headerContainer: {
      zIndex: theme.zIndex.max + 10,
    },
  },
});
